/* assets/menu-deeplink.js (v2)
   Deep-link both drawer (mobile) and desktop megas.
   Examples:
     ?menu=simple-tab
     ?menu=simple-mega
     ?menu=simple-tab&tab=nissan-rb
*/

(() => {
  const norm = s => (s||'').toString().trim().toLowerCase()
    .replace(/\s+/g,'-').replace(/[^a-z0-9\-_]/g,'');

  const qs = new URLSearchParams(location.search);
  const menuQ = norm(qs.get('menu') || qs.get('m') || '');
  const tabQ  = norm(qs.get('tab')  || qs.get('t') || '');
  const catQ  = norm(qs.get('cat')  || qs.get('c') || '');
  const itemQ = norm(qs.get('item') || qs.get('i') || '');

  if (!menuQ && !tabQ && !catQ && !itemQ) return;

  const run = () => {
    const isMobile = window.matchMedia('(max-width: 989.98px)').matches;
    if (isMobile) openDrawerFlow(menuQ, tabQ, catQ, itemQ);
    else openDesktopFlow(menuQ, tabQ);
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', e => { if (e.persisted) run(); });

  /* ---------------- Drawer (mobile) ---------------- */
  async function openDrawerFlow(menu, tab, cat, item) {
    const drawer = await waitFor(() =>
      document.getElementById('menu-drawer') ||
      document.querySelector('.menu-drawer')
    , 5000);
    if (!drawer) return;

    await ensureDrawerOpen(drawer);

    const find = h => h ? drawer.querySelector(`.mm-details[data-handle="${h}"]`) : null;

    if (menu) { const n = find(menu); if (n) { n.open = true; n.scrollIntoView({block:'nearest'}); } }
    if (tab)  { const n = find(tab);  if (n) { n.open = true; n.scrollIntoView({block:'nearest'}); } }
    if (cat)  { const n = find(cat);  if (n) { n.open = true; n.scrollIntoView({block:'nearest'}); } }

    if (item) {
      const a = drawer.querySelector(`a[href*="${item}"], a[href*="${item.replace(/-/g,'_')}"]`);
      if (a) a.scrollIntoView({block:'nearest'});
    }
  }

  async function ensureDrawerOpen(drawerEl) {
    if (isVisible(drawerEl)) return;
    const toggle = document.querySelector('[aria-controls="menu-drawer"]')
      || document.querySelector('button.header__icon--menu, .js-menu-toggle, [data-action="open-drawer"]');
    if (toggle) {
      toggle.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true}));
      await delay(350);
      if (!isVisible(drawerEl)) await delay(400);
    }
  }

  function isVisible(el){
    if (!el) return false;
    const cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  /* ---------------- Desktop ---------------- */
  function openDesktopFlow(menu, tab) {
    // If caller gave us the type, open that top-level menu.
    let top = findDesktopTop(menu);

    // Fallbacks:
    // - If no menu specified but a tab was given, open the first tabbed mega.
    if (!top && tab) top = findTabbedMega();

    // - If caller asked for 'simple-tab' or 'simple-mega' but we didn’t find by data attribute,
    //   try structural match.
    if (!top && (menu === 'simple-tab' || menu === 'tabs' || menu === 'tabbed')) top = findTabbedMega();
    if (!top && (menu === 'simple-mega' || menu === 'simple' || menu === 'mega')) top = findSimpleMega();

    if (!top) return;

    // Open that <details>
    top.setAttribute('open','');

    // If a tab handle is provided, try to activate it
    if (tab) {
      const rail = top.querySelector('.tabs-rail');
      if (rail) {
        const byData = rail.querySelector(`[data-tab="${tab}"]`);
        const byText = byData || Array.from(rail.querySelectorAll('a, [data-tab]'))
          .find(el => norm(el.textContent) === tab);
        if (byText) {
          byText.dispatchEvent(new MouseEvent('mouseenter', {bubbles:true}));
          byText.dispatchEvent(new MouseEvent('click', {bubbles:true}));
        }
      }
    }
  }

  function findDesktopTop(handle){
    if (!handle) return null;

    // Preferred: explicit data attribute on <details>
    const byData = document.querySelector(`.header__inline-menu details[data-menu="${handle}"]`);
    if (byData) return byData;

    // Fallback: match normalized summary text
    const all = document.querySelectorAll('.header__inline-menu details');
    for (const d of all) {
      const txt = d.querySelector('summary')?.textContent || '';
      if (norm(txt) === handle) return d;
    }
    return null;
  }

  function findTabbedMega(){
    const ds = document.querySelectorAll('.header__inline-menu details');
    return Array.from(ds).find(d => d.querySelector('.mega-menu__content .mega-menu--tabs')) || null;
  }
  function findSimpleMega(){
    const ds = document.querySelectorAll('.header__inline-menu details');
    return Array.from(ds).find(d => d.querySelector('.mega-menu__content .mega-menu--simple')) || null;
  }

  /* ---------------- utils ---------------- */
  function delay(ms){ return new Promise(r => setTimeout(r, ms)); }
  function waitFor(testFn, timeout=3000, interval=50){
    return new Promise(resolve => {
      const start = performance.now();
      (function tick(){
        const val = testFn();
        if (val) return resolve(val);
        if (performance.now() - start > timeout) return resolve(null);
        setTimeout(tick, interval);
      })();
    });
  }
})();